
export const formFields = {
    advertiserId: {
      key: 'advertiserId',
      label: 'Advertiser',
      required: true,
      placeholder: '',
      requiredMessage: 'This field is required.',
      displayLayout: 'col-md-7',
      valueKey: 'key',
      textKey: 'value',
      tooltip: '<div> Advertiser </div>'
    },
    masterAccountId: {
      key: 'masterAccountId',
      type: 'text',
      label: 'Master Account ID (MCC)',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      minLength: 3,
      minLengthMessage: 'Minimum 3 characters allowed.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Master Account ID (MCC) </div>',
      // pattern: /^(?=.*?[A-Za-z]).{1,}$/
      pattern: /^[0-9]{1,10}$/
    },
    accountId: {
      key: 'accountId',
      type: 'text',
      label: 'Advertiser ID (CID)',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      minLength: 3,
      minLengthMessage: 'Minimum 3 characters allowed.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Advertiser ID (CID) </div>',
      // pattern: /^(?=.*?[A-Za-z]).{1,}$/
      pattern: /^[0-9]{1,10}$/
    },
  
    currency: {
      key: 'currency',
      label: 'Currency',
      placeholder: '',
      type:"text",
      displayLayout: 'col-md-7',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div>  Currency </div>',
      pattern: /^[A-Za-z]*$/ 
    },
    fbAccountID: {
      key: 'fbAccountID',
      label: 'Account ID',
      required: true,
      placeholder: '',
      requiredMessage: 'This field is required.',
      displayLayout: 'col-md-7',
      valueKey: 'key',
      textKey: 'value',
      tooltip: '<div> Account ID </div>',
      pattern: /^[0-9]{1,10}$/
    },
    fbCurrency: {
      key: 'fbCurrency',
      label: 'Currency',
      placeholder: '',
      type:"text",
      displayLayout: 'col-md-6',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div>  Currency </div>',
      pattern: /^[A-Za-z]*$/  
    },
    DVplatform: {
      key: 'DVplatform',
      label: 'Select Platform',
      displayLayout: 'col-md-7',
      labelLayout: 'col-md-4',
      required: true,
      requiredMessage: 'This field is required.',
      tooltip: '<div>Select Platform</div>',
      valueKey: 'value',
      textKey: 'key',

  },
  dv360AccountID: {
    key: 'dv360AccountID',
    label: 'Account ID',
    required: true,
    placeholder: '',
    requiredMessage: 'This field is required.',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Account ID </div>',
    pattern: /^[0-9]{1,10}$/
  },
  recActiveION: {
    key: 'recActiveION',
    label: 'Select Option',
    placeholder: '',
    required: true,
    displayLayout: 'col-sm-8',
    requiredMessage: 'This field is required.',
    options: [{ id: 1, value: 'Link my Account' },
    { id: 0, value: 'Use Infomo' }],
  },
  recActiveDV360: {
    key: 'recActiveDV360',
    label: 'Select Option',
    placeholder: '',
    required: true,
    displayLayout: 'col-sm-8',
    requiredMessage: 'This field is required.',
    options: [{ id: 1, value: 'Link my Account' },
    { id: 0, value: 'Use Infomo' }],
  },
  dv360Currency: {
    key: 'dv360Currency',
    label: 'Currency',
    placeholder: '',
    type:"text",
    displayLayout: 'col-md-6',
    valueKey: 'key',
    required: true,
    requiredMessage: 'This field  is required.',
    textKey: 'value',
    tooltip: '<div>  Currency </div>',
    pattern: /^[A-Za-z]*$/  
  },
  IONplatform: {
    key: 'IONplatform',
    label: 'Select Platform',
    displayLayout: 'col-md-7',
    labelLayout: 'col-md-4',
    required: true,
    requiredMessage: 'This field is required.',
    tooltip: '<div>Select Platform</div>',
    valueKey: 'value',
    textKey: 'key',
  },
  ionAccountID: {
    key: 'ionAccountID',
    label: 'Account ID',
    required: true,
    placeholder: '',
    requiredMessage: 'This field is required.',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Account ID </div>',
    pattern: /^[0-9]{1,10}$/

  },
  ionCurrency: {
    key: 'ionCurrency',
    label: 'Currency',
    placeholder: '',
    type:"text",
    displayLayout: 'col-md-6',
    valueKey: 'key',
    required: true,
    requiredMessage: 'This field  is required.',
    textKey: 'value',
    tooltip: '<div>  Currency </div>',
    pattern: /^[A-Za-z]*$/  
  },
    budget: {
      key: 'budget',
      type: 'number',
      label: 'Budget',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      minLength: 0,
      min: 0,
      max: 9999999,
      minLengthMessage: 'Minimum 3 characters allowed.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> IO Budget </div>'
    },
    startDate: {
      key: 'startDate',
      label: 'Start Date',
      required: true,
      placeholder: 'Select a date',
      displayLayout: 'col-md-7',
      requiredMessage: 'Start Date is required.',
      tooltip: '<div> Start Date </div>'
    },
    endDate: {
      key: 'endDate',
      label: 'End Date',
      label: 'End Date (Optional)',
      // required: true,
      required: false,
      // placeholder: 'End Date',
      placeholder: 'DD/MM/YYYY',
      displayLayout: 'col-md-7',
      requiredMessage: 'End Date is required.',
      tooltip: '<div> End Date </div>'
    },
    platform: {
      key: 'platform',
      type: 'checkboxGroup',
      label: 'Select Platform',
      required: false,
      requiredMessage: 'This field is required.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Devices Supported </div>',
      valueKey: 'checked',
      textKey: 'value'
  },
  recActiveDV360: {
    key: 'recActiveDV360',
    label: 'Select Option',
    placeholder: '',
    required: true,
    displayLayout: 'col-sm-8',
    requiredMessage: 'This field is required.',
    options: [{ id: 1, value: 'Link my Account' },
    { id: 0, value: 'Use Infomo' }],
  },
  recActiveION: {
    key: 'recActiveION',
    label: 'Select Option',
    placeholder: '',
    required: true,
    displayLayout: 'col-sm-8',
    requiredMessage: 'This field is required.',
    options: [{ id: 1, value: 'Link my Account' },
    { id: 0, value: 'Use Infomo' }],
  },
    // time: {
    //   key: 'time',
    //   label: 'Time',
    //   placeholder: 'HH:MM',
    //   required: true,
    //   requiredMessage: 'Time required.',
    //   tooltip:'<div> Time </div>',
    //   displayLayout: 'col-md-7',
    //   labelLayout: 'col-sm-4',
    // },
  };
  
  export const confirmationMessage = {
    action: {
      confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
      type:'Confirmation'
    }
  }
  
  export const successfullyMessage = {
    action: {
      confirmationMessage: 'Successfully Saved IO Details',
      type: 'alert',
    }
  }
  export  const platformtype=[
    {key: '1', value: 'Google Adwords',  checked: false},
    {key: '2', value: 'Facebook', checked: false},
    {key: '3', value: 'DV 360',  checked: false},
    {key: '4', value: 'ION',  checked: false},
    ]
  
    export  const dvPlatform=[
      {id: '1', key: 'linkAccount',  value: "Link My Account"},
      {id: '2', key: 'useInfo', value: "Use My Info"},
      ]
  
      export  const IONplatform=[
        {key: '1', value: 'Link my Account',  checked: false},
        {key: '2', value: 'Use my info', checked: false},
        ]
  
  
  
  // export const options = [
  //   { text: 'bug', id: 1 },
  //   { text: 'feature', id: 2 },
  //   { text: 'documents', id: 3 },
  //   { text: 'discussion', id: 5 },
  // ];